import React, { useState, useEffect } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import Header from '../dashboard/header';
import Navbar from '../dashboard/navbar';
import Sidebar from '../dashboard/sidebar';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { FaCaretRight, FaCaretDown, FaArrowCircleLeft, FaUserShield, FaCheckCircle, FaUndoAlt } from 'react-icons/fa';
import CommentaireAdmin from './admin_commentaire';
import useAuth from '../dashboard/useAuth';
import axios from 'axios';
import { getAuthToken } from '../../authToken';

// Composant fonctionnel pour le formulaire d'expérience
const Experience_form_admin = () => {
    useAuth(); // Authentication required

    const location = useLocation();
    const navigate = useNavigate(); // Utiliser useNavigate pour la navigation
    const queryParams = new URLSearchParams(location.search);

    const user_id = localStorage.getItem('user_id'); // Récupérer l'ID de l'utilisateur connecté
    const { userData } = location.state || {};

    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Eligibilite"; // Définit le titre de la page
        }
    }, [user_id]);

    const utilisateur_id = localStorage.getItem('utilisateur_id');
    // const formulaire_id = queryParams.get('formulaire_id');

    const [formDataList, setFormDataList] = useState([{
        titre_projet: '',
        organisation: '',
        poste_occupe: '',
        domaine_fonctionnel: '',
        objectif_organisation: '',
        approche_methodologique: '',
        taille_equipe: '',
        budget: '',
        date_debut_projet: '',
        date_fin_projet: '',
        description: '',
    }]);

    const [cumulativeError, setCumulativeError] = useState('');
    const [formulaire_id, setFormulaireId] = useState(null);
    const [expanded, setExpanded] = useState([false]);


    // useEffect(() => {
    //     const fetchIdForm = async () => {
    //         try {
    //             const response = await fetch(process.env.REACT_APP_HOTE + `/recuperer-eligibilite-pour-admin/${utilisateur_id}/`);
    //             if (!response.ok) throw new Error('Erreur réseau');
    //             const data = await response.json();
    //             console.log('Données du formulaire récupérées Id:', data);
    //             if (data.id) {
    //                 setFormulaireId(data.id);
    //             }
    //         } catch (error) {
    //             console.error('Erreur lors de la récupération des données du formulaire:', error);
    //         }
    //     };

    //     fetchIdForm();
    // }, [utilisateur_id]);

    useEffect(() => {
        const fetchExistingData = async () => {
            // if (!formulaire_id) return; // Ajout d'une vérification pour éviter l'exécution si formulaire_id n'est pas défini

            try {
                const token = localStorage.getItem('access_token');

                const response = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-eligibilite-pour-admin/${utilisateur_id}/`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
                // const response = await fetch(process.env.REACT_APP_HOTE + `/recuperer-eligibilite-pour-admin/${utilisateur_id}/`);
                if (!response.ok) {
                    throw new Error("Erreur lors de la récupération des données.");
                }
                const existingData = await response.json();
                console.log('Données existantes récupérées:', existingData); // Vérification de ce qui est récupéré
                setFormulaireId(existingData.id);
                // Vérifiez si des projets existent dans les données récupérées
                if (existingData.experiences && existingData.experiences.length > 0) {
                    setFormDataList(existingData.experiences);
                } else {
                    // Si aucun projet n'existe, laissez le formulaire vide
                    setFormDataList([{
                        titre_projet: '',
                        organisation: '',
                        poste_occupe: '',
                        domaine_fonctionnel: '',
                        objectif_organisation: '',
                        approche_methodologique: '',
                        taille_equipe: '',
                        budget: '',
                        date_debut_projet: '',
                        date_fin_projet: '',
                        description: '',
                    }]);
                }
            } catch (error) {
                console.error('Erreur lors de la récupération des données du formulaire:', error);
                setCumulativeError('Erreur lors de la récupération des données.');
            }
        };

        fetchExistingData();
    }, [formulaire_id, utilisateur_id]); // Ajout de formulaire_id comme dépendance


    const [totalMonths, setTotalMonths] = useState(0); // État pour stocker le total des mois
    const [monthsForProjects, setMonthsForProjects] = useState([]); // État pour stocker les mois par projets

    // Calculer la durée en mois entre deux dates
    const calculateMonths = (startDate, endDate) => {
        const start = new Date(startDate);
        const end = new Date(endDate);
        return (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
    };
    // Vérification du total des mois
    useEffect(() => {
        let total = 0;
        const monthsList = [];
        formDataList.forEach((formData) => {
            if (formData.date_debut_projet && formData.date_fin_projet) {
                total += calculateMonths(formData.date_debut_projet, formData.date_fin_projet);
                const months = calculateMonths(formData.date_debut_projet, formData.date_fin_projet);
                monthsList.push(months); // Ajoute la durée de ce projet en mois dans monthsList
            }
        });

        setTotalMonths(total);
        setMonthsForProjects(monthsList);
    }, [formDataList]);

    const handleToggle = (index) => {
        const newExpanded = [...expanded];
        newExpanded[index] = !newExpanded[index]; // Basculer l'état d'expansion
        setExpanded(newExpanded);
    };


    const handleReturn = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(`${process.env.REACT_APP_HOTE}/renvoyer-eligibilite/${formulaire_id}/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            if (!response.ok) {
                throw new Error("Erreur lors de la récupération des données.");
            }
            // const existingData = await response.json();
            navigate(`/Eligibilites-soumises`);
        } catch (error) {
            console.error('Erreur lors de la récupération des données du formulaire:', error);
            setCumulativeError('Erreur lors de la récupération des données.');
        }
        navigate(`/Eligibilites-soumises`);  // Navigue vers la liste
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(`${process.env.REACT_APP_HOTE}/valider-eligibilite/${formulaire_id}/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            if (!response.ok) {
                throw new Error("Erreur lors de la récupération des données.");
            }
            // const existingData = await response.json();
            navigate(`/Eligibilites-soumises`);
        } catch (error) {
            console.error('Erreur lors de la récupération des données du formulaire:', error);
            setCumulativeError('Erreur lors de la récupération des données.');
        }
    };

    // Fonction pour retourner à la page précédente
    const handleBackClick = () => {
        navigate(`/Eligibilite-admin`);  // Navigue vers la première partie du formulaire
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("AdminEligibilite")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }



    return (
        <div id="wrapper" style={{ fontFamily: 'Arial, sans-serif' }}>
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><FaUserShield size={25} className='mr-2' />Dossier de {userData.nom} {userData.prenoms} </h2>
                            <small>Administration des Eligibilités.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {/* Utiliser Link de react-router-dom pour la navigation */}
                                        <Link to={`/admin`}>Administraion</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {/* Utiliser Link de react-router-dom pour la navigation */}
                                        <Link to={`/Eligibilites-soumises`}>Eligibilite</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {/* Utiliser Link de react-router-dom pour la navigation */}
                                        <span>Dossier de {userData.nom} {userData.prenoms} </span>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    {/* <Header titre="Eligibilité" sous_titre="Dashboard" sous_titre1="Eligibilite" /> */}
                    <div className="d-flex flex-wrap justify-content-between">
                        <div className="col-lg-8 col-md-6 col-sm-12 mx-auto m-4">
                            <div className="ibox-content">
                                <h3 className="text-success" style={{ marginBottom: '0px', textTransform: 'uppercase', fontSize: '13px' }}>
                                    Experience Project / Expérience Projet : {totalMonths} mois
                                </h3>
                                <hr className="mt-2 text-success" style={{ borderTop: '1px solid' }} />
                                {formDataList.map((formData, index) => (
                                    <div key={index}>
                                        <div className=' mb-4' onClick={() => handleToggle(index)} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                            {expanded[index] ? <FaCaretDown style={{ fontSize: '24px' }} /> : <FaCaretRight style={{ fontSize: '24px' }} />}
                                            <span className="ms-2" style={{ fontSize: '15px' }}>{formData.titre_projet} {monthsForProjects && (<span>: {monthsForProjects[index]} mois </span>)}</span>
                                        </div>
                                        {expanded[index] && (
                                            <div> <hr className="mt-2 text-muted" style={{ borderTop: '1px solid' }} />
                                                {cumulativeError && <Alert variant="danger" className="mt-3">{cumulativeError}</Alert>}
                                                <Form>
                                                    <div className="row">
                                                        <div className="col-lg-6">
                                                            <Form.Group controlId={`titreprojet_${index}`} className="mb-3">
                                                                <Form.Label style={{ display: 'block' }}> Titre du projet <small style={{ display: 'block' }}>Project Title</small></Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    value={formData.titre_projet}
                                                                    readOnly
                                                                />
                                                            </Form.Group>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <Form.Group controlId={`organisation_${index}`} className="mb-3">
                                                                <Form.Label style={{ display: 'block' }}> Organisation <small style={{ display: 'block' }}>Organization</small></Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    value={formData.organisation}
                                                                    readOnly
                                                                />
                                                            </Form.Group>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <Form.Group controlId={`poste_occupe_${index}`} className="mb-3">
                                                                <Form.Label style={{ display: 'block' }}> Poste occupé <small style={{ display: 'block' }}>Job Title</small></Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    value={formData.poste_occupe}
                                                                    readOnly
                                                                />
                                                            </Form.Group>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <Form.Group controlId={`domaine_fonctionnel_${index}`} className="mb-3">
                                                                <Form.Label style={{ display: 'block' }}> Domaine fonctionnel <small style={{ display: 'block' }}>Functional Reporting Area</small></Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    value={formData.domaine_fonctionnel}
                                                                    readOnly
                                                                />
                                                            </Form.Group>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <Form.Group controlId={`objectif_organisation_${index}`} className="mb-3">
                                                                <Form.Label style={{ display: 'block' }}> Secteur d'activité <small style={{ display: 'block' }}>Organization Primary Focus</small></Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    value={formData.objectif_organisation}
                                                                    readOnly
                                                                />
                                                            </Form.Group>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <Form.Group controlId={`approche_methodologique_${index}`} className="mb-3">
                                                                <Form.Label style={{ display: 'block' }}> Approche méthodologique <small style={{ display: 'block' }}>Approach Methodology</small></Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    value={formData.approche_methodologique}
                                                                    readOnly
                                                                />
                                                            </Form.Group>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <Form.Group controlId={`taille_equipe_${index}`} className="mb-3">
                                                                <Form.Label style={{ display: 'block' }}> Taille de l'équipe <small style={{ display: 'block' }}>Project Team Size</small></Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    value={formData.taille_equipe}
                                                                    readOnly
                                                                />
                                                            </Form.Group>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <Form.Group controlId={`budget_${index}`} className="mb-3">
                                                                <Form.Label style={{ display: 'block' }}> Budget du projet <small style={{ display: 'block' }}>Project Budget</small></Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    value={formData.budget}
                                                                    readOnly
                                                                />
                                                            </Form.Group>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <Form.Group controlId={`date_debut_projet_${index}`} className="mb-3">
                                                                <Form.Label style={{ display: 'block' }}> Date début projet <small style={{ display: 'block' }}>Project Start Date</small></Form.Label>
                                                                <Form.Control
                                                                    type="date"
                                                                    value={formData.date_debut_projet}
                                                                    readOnly
                                                                />
                                                            </Form.Group>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <Form.Group controlId={`date_fin_projet_${index}`} className="mb-3">
                                                                <Form.Label style={{ display: 'block' }}> Date fin projet <small style={{ display: 'block' }}>Project End Date</small></Form.Label>
                                                                <Form.Control
                                                                    type="date"
                                                                    value={formData.date_fin_projet}
                                                                    readOnly
                                                                />
                                                            </Form.Group>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <Form.Group controlId={`description_${index}`} className="mb-3">
                                                                <Form.Label> Description du projet / Project Description</Form.Label>
                                                                <Form.Control
                                                                    as="textarea"
                                                                    rows={4}
                                                                    value={formData.description}
                                                                    readOnly
                                                                />
                                                            </Form.Group>
                                                        </div>
                                                    </div>
                                                </Form>
                                            </div>
                                        )}
                                        {/* <hr className="mt-2 text-success" style={{ borderTop: '1px solid' }} /> */}
                                    </div>
                                ))}
                                <div className="d-flex justify-content-end" style={{ gap: '10px' }}>
                                    <Button variant="success" size="sm" onClick={handleBackClick}><FaArrowCircleLeft className='mr-1' /> Précédent</Button>
                                    <Button variant="success" size="sm" onClick={handleReturn}><FaUndoAlt className='mr-1' /> A Revoir</Button>
                                    <Button variant="success" size="sm" onClick={handleSubmit} className="ms-2"><FaCheckCircle className='mr-1' /> Valider</Button>
                                </div>

                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mx-auto col-sm-12 m-4 ">
                            <div className="ibox-content">
                                <h4 className="text-success" style={{ textTransform: 'uppercase' }}>Commentaires</h4>
                                <hr className="mt-2 text-success" style={{ borderTop: '1px solid ' }} />
                                <CommentaireAdmin formulaire_id={formulaire_id} user_id={user_id} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Experience_form_admin;

